import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    showSplitView: false,
    report: "",
    targetCaption: "",
    targetColumn: "",
    period: "",
    amountCol: "",
    reportName: "",
    editedCaptions: "",
    cfsLib: "",
    data: "",
    fileType:"",
    // Which JE List filter (All / Correct / Error) the JE view should open on.
    // The Checks page's 5.2 row links straight to the offending entries, so it
    // asks for "error"; everything else opens on "all".
    jeEntryFilter: "all",
    upLoadedExcelsData:null,
    isCameThroughHyperLink:false,
    cameFromReportName:null,
    clickedRowData:[],
    glData: null,
    selectedEntry: null,
    journalData: null,
    activeFilter: {},
    cfsWpUniqueEntry: {
        cfsIndirectRows: "",
        cfsDirectRows: "",
        cfsEntriesMethod: "",
        selectedSplitedEntryId: "",
        uploadedPeriods: ""
    },
    selectedSplitedEntryIdInner: "",
    uploadedExcelFilesChecksState : {
        uploadedRawData:null,
        period:null,
        journalData:null,
        formState:null,
        glData:null,
        coaData:null
    }
}

const splitView = createSlice({
    name: 'SPLITVIEWSLICE',
    initialState,
    reducers: {
        showSplitViewHandler(state, action) {
            state.showSplitView = action?.payload?.showSplitView || false;
            state.report = action?.payload?.report || "";
            state.targetCaption = action?.payload?.targetCaption || "";
            state.targetColumn = action?.payload?.targetColumn || "";
            state.period = action?.payload?.period || "";
            state.amountCol = action?.payload?.amountCol || "";
            state.reportName = action?.payload?.reportName || "";
            state.editedCaptions = action?.payload?.editedCaptions || "";
            state.cfsLib = action?.payload?.cfsLib || "";
            state.data = action?.payload?.data || "";
            state.fileType = action?.payload?.fileType || "";
            state.isCameThroughHyperLink = false;
            state.clickedRowData = [];
            state.cfsWpUniqueEntry = action?.payload?.cfsWpUniqueEntry || {}
            state.glData = action?.payload?.glData;
            state.selectedEntry = action?.payload?.selectedEntry;
            state.journalData = action?.payload?.journalData;
            state.selectedSplitedEntryIdInner = action?.payload?.selectedSplitedEntryIdInner || "";
            state.activeFilter = action?.payload?.activeFilter;
        },
        closeSplitViewHandler(state) {
            return {...initialState, upLoadedExcelsData:state.upLoadedExcelsData, uploadedExcelFilesChecksState: state.uploadedExcelFilesChecksState  };
        },
        setUpLoadedExcelsData(state, action) {
            state.upLoadedExcelsData = action?.payload?.upLoadedExcelsData || null
        },
        setIsCameThroughHyperLink(state, action) {
            // console.log("action",action?.payload)
            state.isCameThroughHyperLink = action?.payload?.isCameThroughHyperLink ?? false;
            state.clickedRowData = action?.payload?.clickedRowData ?? [];
            state.fileType = action?.payload?.fileType ?? "";
            state.jeEntryFilter = action?.payload?.jeEntryFilter || "all";
            // The Checks split view is two-column, so a hyperlink there has to say
            // WHICH period's file to open -- without this it kept whatever period
            // setUpLoadedExcelFilesCheckState last wrote (the period whose Checks
            // button was clicked), so period-two cells opened period one's file.
            // Callers that don't pass a period keep the existing one, as before.
            if (action?.payload?.period) {
                state.period = action.payload.period;
            }
            if (action?.payload?.cameFromReportName) {
                state.cameFromReportName = action?.payload?.cameFromReportName
                state.report = action?.payload?.report;
            }
        },
        clearFileType(state) {
            state.fileType = null;
        },
        setUpLoadedExcelFilesCheckState(state, action) {
            state.uploadedExcelFilesChecksState = action?.payload;
            state.report = "quckbook-excel-checks";
            state.showSplitView = true;
            state.period = action?.payload?.period;
        },
        // Fills the same snapshot from the ARCHIVED upload (see the Checks page's
        // loadSavedInputChecks), for reading the input checks again after the
        // in-memory one is gone. Unlike setUpLoadedExcelFilesCheckState it does not
        // open the split view or repoint `report` -- the Checks page shows this in
        // its own full-page overlay, and the split view underneath belongs to
        // whatever report the user was already looking at.
        setInputChecksSnapshot(state, action) {
            state.uploadedExcelFilesChecksState = action?.payload;
        },
        // Spec "Show Report": switches the split view between the Checks list
        // ("quckbook-excel-checks") and the CoA-GL-TB comparison report
        // ("quckbook-excel-checks-report") without touching uploadedExcelFilesChecksState,
        // since both views read the same already-loaded CoA/GL/TB data.
        setSplitViewReport(state, action) {
            state.report = action?.payload || "";
        },
        clearUpLoadedExcelFilesCheckState(state,) {
            state.uploadedExcelFilesChecksState = {
                uploadedRawData: null,
                period: null,
                journalData: null,
                formState: null,
                glData: null,
                coaData: null
            };
            state.showSplitView = false
            state.report = "";
        }
    }
});

export const { showSplitViewHandler, setUpLoadedExcelsData, setIsCameThroughHyperLink, setUpLoadedExcelFilesCheckState, setInputChecksSnapshot, setSplitViewReport, clearUpLoadedExcelFilesCheckState, clearFileType, closeSplitViewHandler } = splitView.actions

export default splitView;